import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Config from "../../../config/config";
import { refreshAccessToken } from "../../Authorization/authSlice";
//import { updateMessagesAdmin } from "../Messages/messageslice";

const serverPath = Config.serverPath;


//CREATE NEW TASK
export const addNewTask = createAsyncThunk(
    "tasks/addNewTask",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/add";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                titleTask: item.titleTask,
                
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(addNewTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD CREATE NEW TASK');
      return response.status;
      }
        
    }
);
//UPDATE NAME  TASK
export const updateNameTask = createAsyncThunk(
    "tasks/updateNameTask",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/updatename";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                titleTask: item.titleTask,
                taskId: item.taskId
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(updateNameTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD CREATE NEW TASK');
      return response.status;
      }
        
    }
);
//UPDATE GROUP TASK
export const updateGroupTask = createAsyncThunk(
    "tasks/updateGroupTask",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/updategroup";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                    taskId: item.taskId,
                    groupId: item.groupId,
                    publicOption: item.publicOption
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(updateGroupTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD UPDATE GROUP TASK');
      return response.status;
      }
        
    }
);
// GET TASK DATA MAIN

export const getTaskDataMain = createAsyncThunk(
    "tasks/getTaskDataMain", async(taskId, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/get/";
        const urlToFetch = `${url}${taskId}`;
        console.log('start get task data main!');
        const response = await fetch(urlToFetch
            , {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
          
           credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        
        if (response.ok) {
            const answer = await response.json();
           
           // console.log(jsonResponse);
           return answer;

           //REFRESH ACCESS TOKEN IF 401
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(getTaskDataMain(taskId));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD GET library');
      return response.status;
      }
    }
);

//DELETE ID TASK
export const deleteTask = createAsyncThunk(
    "tasks/deleteTask", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/tasks/delete/";
        const urlToFetch = `${url}${item.taskId}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(deleteTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD DELETE ITEM TASK');
      return response.status;
      }

    }
);
//DELETE GROUP ID TASK
export const deleteGroupTask = createAsyncThunk(
    "tasks/deleteGroupTask", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/tasks/deletegroup/";
        const urlToFetch = `${url}${item.taskId}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(deleteGroupTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD DELETE GROUP ITEM TASK');
      return response.status;
      }

    }
);

//UPDATE START TASK
export const startTaskUpdate = createAsyncThunk(
    "tasks/startTaskUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/tasks/update/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                taskId: item.taskId,
                started: item.started,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
           // console.log(answer[0]);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(startTaskUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD START USER TASK');
      return response.status;
      }

    }
);

//GET ALL DATA FOR TASKS
export const getAllDataForTasks = createAsyncThunk(
    "tasks/getAllDataForTasks", async(taskId, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/data/";
        const urlToFetch = `${url}`;
        console.log('start get task data main!');
        const response = await fetch(urlToFetch
            , {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
          
           credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        
        if (response.ok) {
            const answer = await response.json();
           
           // console.log(jsonResponse);
           return answer;

           //REFRESH ACCESS TOKEN IF 401
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(getAllDataForTasks());
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD GET all data for tasks');
      return response.status;
      }
    }
);
//ADD NEW QUIZ TO TASK
export const addNewQuiz= createAsyncThunk(
    "tasks/addNewQuiz",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/addquiz";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                quizId: item.quizId,
                taskId: item.taskId,
                orderType: item.orderType,
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(addNewQuiz(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD CREATE NEW TASK');
      return response.status;
      }
        
    }
);
//UPDATE QUIZ TASK
export const updateQuizTask = createAsyncThunk(
    "tasks/updateQuizTask",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/updatequiz";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                    quizId: item.quizId,
                    taskId: item.taskId,
                    orderType: item.orderType
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            //console.log(answer[0]);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(updateQuizTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD UPDATE GROUP TASK');
      return response.status;
      }
        
    }
);
//DELETE ID TASK
export const deleteQuizTask = createAsyncThunk(
    "tasks/deleteQuizTask", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/tasks/deletequiz/";
        const urlToFetch = `${url}${item.taskId}/${item.quizId}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(deleteQuizTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD DELETE ITEM TASK');
      return response.status;
      }

    }
);
//UPDATE PAID OPTION TASK
export const updatePaidOptionTask = createAsyncThunk(
    "tasks/updatePaidOptionTask",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/tasks/updatepaid";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                    paid: item.paid,
                    taskId: item.taskId,
                    price: item.price
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            //console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(updatePaidOptionTask(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD UPDATE GROUP TASK');
      return response.status;
      }
        
    }
);

//INITIAL STATE
const initialState ={
   tasksDataMain:[],
   userTasks:[],
   userCreatorTasks:[],
   openStartedForm: false,
   openDeleteTaskForm: false,
   openDeleteGroupTaskForm: false,
   selectedTaskIdForQuizes:0,
   selectedTaskNameForQuizes:'',
   openDeleteQuizTaskForm: false,
   openEditPaidTaskForm: false,
    tasksPublic:[],
    tasksPrivate:[],
};

const options = {
    name: 'tasks',
    initialState: {
        tasksDataMain:[],
        finishedQuizes: [],
        userTasks:[],
        userCreatorTasks:[],
        openStartedForm: false,
        taskIdForStartedForm: 0,
        startedForStartedForm: false,
        valueForStartedForm: false, // TASK STARTED OR STOPED
        openDeleteTaskForm: false,
        openDeleteGroupTaskForm: false,
        openEditPaidTaskForm: false,
        selectedTaskIdForQuizes:0,
        selectedTaskNameForQuizes:'',
        categoryData:[/*{id:1, label:'жб'}, {id:2, label:'сталь'}*/],
        subcategoryData:[/*
            {sub_id:1, main_id:1, text:'жб222', public: true}, 
            {sub_id:2, main_id:2, text:'st111', public: false},
            {sub_id:3, main_id:2, text:'st11133', public: false}*/],
        quizesData:[/*
            {quiz_id:1,sub_id:1, main_id:1, text:'test жб121212', public: true}, 
            {quiz_id:2,sub_id:1, main_id:1, text:'testжб232323', public: false},
            {quiz_id:3,sub_id:2, main_id:2, text:'testst232323', public: false}*/],
        openDeleteQuizTaskForm: false,
        tasksPublic:[],
        tasksPrivate:[],
    },
reducers: {
    getInitialStateForTasks: state  => 
    initialState,
    sortedDataFinishedQuizes: (state, action) => { 
        state.finishedQuizes = action.payload;
    },
    getUserTasks: (state, action) => {
        state.userTasks = action.payload;
    },
    getUserCreatorTasks: (state, action) => {
        state.userCreatorTasks = action.payload;
    },
    getPublicTasks: (state, action) => {
        state.tasksPublic = action.payload;
    },
    getPrivateTasks: (state, action) => {
        state.tasksPrivate = action.payload;
    },
    viewStartedForm: (state, action) => {
        state.openStartedForm = !state.openStartedForm;
    },
    closeStartedForm: (state, action) => {
        state.openStartedForm = false;
    },
    setTaskIdForStartedForm: (state, action) => {
        state.taskIdForStartedForm = action.payload;
    },
    setStartedForStartedForm: (state, action) => {
        state.startedForStartedForm = action.payload;
    },
    setValueForStartedForm: (state, action) => {
        state.valueForStartedForm = action.payload;
    },
    setOpenDeleteTaskForm: (state) => {
            state.openDeleteTaskForm = true;
        },
    
    setOpenDeleteQuizTaskForm: (state) => {
            state.openDeleteQuizTaskForm = true;
        },
    setOpenDeleteGroupTaskForm: (state) => {
            state.openDeleteGroupTaskForm = true;
        },
    setOpenEditPaidTaskForm: (state) => {
            state.openEditPaidTaskForm = true;
        },
    closeEditPaidTaskForm: (state) => {
            state.openEditPaidTaskForm = false;
        },
    closeDeleteTaskForm: (state) => {
            state.openDeleteTaskForm = false;
        },
    closeDeleteGroupTaskForm: (state) => {
            state.openDeleteGroupTaskForm = false;
        },
    closeDeleteQuizTaskForm: (state) => {
            state.openDeleteQuizTaskForm = false;
        },
    deleteGroupContactFromTask: (state, action) => {
        console.log(action.payload);
        if (action.payload.length !== 0) {
            const groupId = action.payload[0].id
            state.userCreatorTasks.forEach(item => {
                if (item.group_id === groupId) {
                    item.group_id = null;
                    item.group_name = '';
                }
            })
        } else return null;
    },
    setIdNameTaskForQuizes: (state, action) => {
        state.selectedTaskIdForQuizes = action.payload.taskId;
        state.selectedTaskNameForQuizes = action.payload.taskName;
    }

},
extraReducers(builder) {
    builder
 

    //LOAD TASK DATA MAIN
    .addCase(getTaskDataMain.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(getTaskDataMain.fulfilled, (state, action) => {
       if (action.payload) {
        if (action.payload.length !==0 ) {
        console.log(action.payload);
        
        let data=
            {
            taskId:action.payload[0].task_id,
            taskData:action.payload,
           };
    
             //add resolved quiz to finished if exist 
             if (state.finishedQuizes.length !== 0) {

                const  taskQuizesData = [];
                   data.taskData.forEach(item => {
                     let resultIndex;
   
                     resultIndex = state.finishedQuizes.findIndex(arg => 
                           item.quiz_id === arg.quiz_id);
                            
                   console.log(resultIndex);
                   if (resultIndex !== -1) {
                       taskQuizesData.push({
                           quiz_id:item.quiz_id,
                           quiz_name: item.quiz_name,
                           quiz_resolved: state.finishedQuizes[resultIndex].quiz_resolved,
                           order_type: item.order_type,
                           publisher: item.publisher
                       })
                   } else {
                           taskQuizesData.push({
                           quiz_id:item.quiz_id,
                           quiz_name: item.quiz_name,
                           quiz_resolved: null,
                           order_type: item.order_type,
                           publisher: item.publisher
                       })
                   }
    
                })
                console.log(taskQuizesData);
                state.tasksDataMain.push({
                    taskId: data.taskId,
                    taskData: taskQuizesData,
                })
            } else {
                state.tasksDataMain.push(data);
            }

        state.isFetching = true;
        state.error = false;
        }
        }
    })
    .addCase(getTaskDataMain.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong get task data main rejected!!!");
    })

   //UPDATE USER TASK START
   
   .addCase(startTaskUpdate.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(startTaskUpdate.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload !== 403){
        if (action.payload) {

            const index = state.userTasks.findIndex(item => item.task_id === action.payload.task_id);
            console.log(index);
            if (index !== -1) {
                state.userTasks[index].started = action.payload.started;
            } else {
                
                state.userTasks.push(action.payload);
            }
        } else {
            console.log('there is no group in task');
        }
           
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(startTaskUpdate.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong update task start rejected!!!");
    })
   //ADD NEW TASK 
   
   .addCase(addNewTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(addNewTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {


                
            state.userCreatorTasks.push(action.payload);
            state.tasksPrivate.push(action.payload);
            state.userTasks.push(action.payload);
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(addNewTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong add task  rejected!!!");
    })
       //UPDATE NAME TASK 
   
   .addCase(updateNameTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(updateNameTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {

            const index = state.userCreatorTasks.findIndex(item => item.task_id === action.payload.task_id);
            console.log(index);
            if (index !== -1) {
                state.userCreatorTasks[index].title = action.payload.title;
            } else return null;
           //UPDATE IN tasksPRIVATE OR Public
            if (action.payload.public) { 
                const index = state.tasksPublic.findIndex(item => item.task_id === action.payload.task_id);
                //console.log(index);
                if (index !== -1) {
                    state.tasksPublic[index].title = action.payload.title;
                } else return null;
            } else {
                const index = state.tasksPrivate.findIndex(item => item.task_id === action.payload.task_id);
                //console.log(index);
                if (index !== -1) {
                    state.tasksPrivate[index].title = action.payload.title;
                } else return null;
            }
           //UPDATE IN USERS TASK
            const index1 = state.userTasks.findIndex(item => item.task_id === action.payload.task_id);
                //console.log(index);
                if (index1 !== -1) {
                    state.userTasks[index1].title = action.payload.title;
                } else return null;

                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(updateNameTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong update name task  rejected!!!");
    })
           //UPDATE GROUP TASK 
   
   .addCase(updateGroupTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(updateGroupTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {

            const index = state.userCreatorTasks.findIndex(item => item.task_id === action.payload.data.task_id);
            console.log(index);
            if (index !== -1) {
                state.userCreatorTasks[index].group_id = action.payload.data.group_id;
                state.userCreatorTasks[index].group_name = action.payload.data.group_name;
                state.userCreatorTasks[index].public = action.payload.data.public;

            } 
            
            state.tasksPublic = action.payload.tasksPublic;
            state.tasksPrivate = action.payload.tasksPrivate;
           state.userTasks = action.payload.userTasks;
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(updateGroupTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong update name task  rejected!!!");
    })
               //DELETE GROUP TASK 
   
   .addCase(deleteGroupTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(deleteGroupTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {

            const index = state.userCreatorTasks.findIndex(item => item.task_id === action.payload.data.task_id);
            console.log(index);
            if (index !== -1) {
                state.userCreatorTasks[index].group_id = null;
                state.userCreatorTasks[index].group_name = '';
                state.userCreatorTasks[index].public = action.payload.data.public;
                

            } 
            const index1= state.tasksPublic.findIndex(item => item.task_id === action.payload.data.task_id);
           state.tasksPublic.splice(index1,1);
           state.tasksPrivate=action.payload.tasksPrivate;
               
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(deleteGroupTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong delete group task  rejected!!!");
    })
                //DELETE TASK
            .addCase(deleteTask.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
                
            }) 
            .addCase(deleteTask.fulfilled, (state, action) => {
                state.isFetching = true;
                    console.log(action.payload);
                   if (action.payload || action.payload.length !== 0) {
                    const index = state.userCreatorTasks.findIndex(item => 
                        item.task_id === action.payload[0].task_id);
                   // console.log(index);
                    state.userCreatorTasks.splice(index,1);

                    //DELETE FROM tasksPRIVATE OR Public
                    if (action.payload[0].public) {
                        const index = state.tasksPublic.findIndex(item => 
                        item.task_id === action.payload[0].task_id);
                   // console.log(index);
                        state.tasksPublic.splice(index,1);
                    } else {
                         const index = state.tasksPrivate.findIndex(item => 
                        item.task_id === action.payload[0].task_id);
                   // console.log(index);
                        state.tasksPrivate.splice(index,1);
                    }

                    //DELETE FROM USERS TASK
                    const index1 = state.userTasks.findIndex(item => 
                        item.task_id === action.payload[0].task_id);
                   // console.log(index);
                        state.userTasks.splice(index1,1);


                    }
            }) 
    
            .addCase(deleteTask.rejected, (state, action) => {
                    state.isFetching = false;
                    state.error = action.payload;
                    state.errorMessage = 'Сервер временно недоступен';
                    state.userMessage ='';
                    console.log('bad delete task');
                })
                    //LOAD TASK DATA MAIN
    .addCase(getAllDataForTasks.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(getAllDataForTasks.fulfilled, (state, action) => {
       if (action.payload) {
        if (action.payload.length !==0 ) {
        console.log(action.payload);
        state.categoryData = action.payload.category;   
        state.subcategoryData = action.payload.subcategory;
        state.quizesData = action.payload.quizes;
        state.isFetching = true;
        state.error = false;
        }
        }
    })
    .addCase(getAllDataForTasks.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong get all data for tasks rejected!!!");
    })
       //ADD NEW QUIZ TO TASK 
   
   .addCase(addNewQuiz.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(addNewQuiz.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload.length !== 0) {

            const index = state.tasksDataMain.findIndex(item => 
                        item.taskId === action.payload[0].task_id
                    
                    );
                console.log(index);
                
            if (index !== -1) {
                state.tasksDataMain[index].taskData = action.payload;
          } else {
            const taskId = action.payload[0].task_id;
            const taskData = action.payload;
            const data = {
                taskId: taskId,
                taskData: taskData,
            }

            state.tasksDataMain.push(data);
          }
           
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(addNewQuiz.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong add task  rejected!!!");
    })
           //UPDATE QUIZ TASK 
   
   .addCase(updateQuizTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(updateQuizTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {

            const index = state.tasksDataMain.findIndex(item => item.task_id === action.payload.task_id);
            console.log(index);
            if (index !== -1) {
                state.tasksDataMain[index].taskData = action.payload;
            } else return null;
          
           
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(updateQuizTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong update name task  rejected!!!");
    })
                //DELETE QUIZ TASK
            .addCase(deleteQuizTask.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
                
            }) 
            .addCase(deleteQuizTask.fulfilled, (state, action) => {
                state.isFetching = true;
                    console.log(action.payload);
                   if (action.payload || action.payload.length !== 0) {
                    const index = state.tasksDataMain.findIndex(item => 
                        item.taskId === action.payload[0].task_id);
                    console.log(index);
                    if (index !== -1) {
                        state.tasksDataMain[index].taskData = action.payload;
                    } else return null;

                    }
            }) 
    
            .addCase(deleteQuizTask.rejected, (state, action) => {
                    state.isFetching = false;
                    state.error = action.payload;
                    state.errorMessage = 'Сервер временно недоступен';
                    state.userMessage ='';
                    console.log('bad delete quiz task');
                }) 
           //UPDATE PAID OPTION TASK 
   
   .addCase(updatePaidOptionTask.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(updatePaidOptionTask.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {

            const index = state.userCreatorTasks.findIndex(item => item.task_id === action.payload.task_id);
            console.log(index);
            if (index !== -1) {
                state.userCreatorTasks[index].task_id = action.payload.task_id;
                state.userCreatorTasks[index].paid = action.payload.paid;
                state.userCreatorTasks[index].price = action.payload.price;
            } else return null;
          
           
                
            state.isFetching = true;
            state.error = false;
        }
    })
    .addCase(updatePaidOptionTask.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong update name task  rejected!!!");
    })   
    }

        

};

export const  tasksSlice = createSlice(options);
export const {sortedDataFinishedQuizes, getUserTasks, getUserCreatorTasks,viewStartedForm, closeStartedForm,
    setStartedForStartedForm, setTaskIdForStartedForm, setValueForStartedForm, setOpenDeleteTaskForm, 
    closeDeleteTaskForm, deleteGroupContactFromTask, setOpenDeleteGroupTaskForm, closeDeleteGroupTaskForm,
    setIdNameTaskForQuizes, closeDeleteQuizTaskForm, setOpenDeleteQuizTaskForm, getPublicTasks, getPrivateTasks, 
    getInitialStateForTasks, setOpenEditPaidTaskForm, closeEditPaidTaskForm
} = tasksSlice.actions;
export default tasksSlice.reducer;


